import React from "react";
import { useNavigate } from "react-router-dom";
import "../static/css/AdminPublications.css";


const AdminInsolvencyCases = () => {
    const navigate = useNavigate();

    return (
        <div className="admin-container" style={{ padding: "2rem" }}>
            <h2 style={{
                marginBottom: "2rem",
                color: "#009688",
                fontSize: "2rem",
                borderBottom: "2px solid #009688",
                paddingBottom: "1rem"
            }}>
                Insolvency Cases Management
            </h2>

            <div style={{
                display: "grid",
                gridTemplateColumns: "repeat(auto-fit, minmax(300px, 1fr))",
                gap: "2rem",
                marginTop: "2rem"
            }}>

                {/* Ganga Case Card */}
                <div style={{
                    background: "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
                    borderRadius: "12px",
                    padding: "2rem",
                    color: "#fff",
                    boxShadow: "0 10px 30px rgba(0,0,0,0.2)",
                    transition: "transform 0.3s ease, box-shadow 0.3s ease",
                    cursor: "pointer"
                }}
                    onMouseEnter={(e) => {
                        e.currentTarget.style.transform = "translateY(-5px)";
                        e.currentTarget.style.boxShadow = "0 15px 40px rgba(0,0,0,0.3)";
                    }}
                    onMouseLeave={(e) => {
                        e.currentTarget.style.transform = "translateY(0)";
                        e.currentTarget.style.boxShadow = "0 10px 30px rgba(0,0,0,0.2)";
                    }}
                    onClick={() => navigate("/adminganga")}
                >
                    <div style={{ fontSize: "3rem", marginBottom: "1rem" }}>🔗</div>
                    <h3 style={{
                        fontSize: "1.5rem",
                        marginBottom: "1rem",
                        fontWeight: "bold"
                    }}>
                        Ganga
                    </h3>
                    <p style={{
                        fontSize: "1rem",
                        opacity: 0.9,
                        marginBottom: "1.5rem",
                        lineHeight: "1.6"
                    }}>
                        Manage and edit the Ganga insolvency case content
                    </p>
                    <div style={{
                        display: "flex",
                        alignItems: "center",
                        gap: "0.5rem",
                        fontSize: "0.9rem",
                        opacity: 0.8
                    }}>
                        <span>🌐</span>
                        <span>ibcupdates.com/ganga</span>
                    </div>
                </div>

                {/* Sakthi Ganesh Case Card */}
                <div style={{
                    background: "linear-gradient(135deg, #f093fb 0%, #f5576c 100%)",
                    borderRadius: "12px",
                    padding: "2rem",
                    color: "#fff",
                    boxShadow: "0 10px 30px rgba(0,0,0,0.2)",
                    transition: "transform 0.3s ease, box-shadow 0.3s ease",
                    cursor: "pointer"
                }}
                    onMouseEnter={(e) => {
                        e.currentTarget.style.transform = "translateY(-5px)";
                        e.currentTarget.style.boxShadow = "0 15px 40px rgba(0,0,0,0.3)";
                    }}
                    onMouseLeave={(e) => {
                        e.currentTarget.style.transform = "translateY(0)";
                        e.currentTarget.style.boxShadow = "0 10px 30px rgba(0,0,0,0.2)";
                    }}
                    onClick={() => navigate("/adminsakthiganesh")}
                >
                    <div style={{ fontSize: "3rem", marginBottom: "1rem" }}>🔗</div>
                    <h3 style={{
                        fontSize: "1.5rem",
                        marginBottom: "1rem",
                        fontWeight: "bold"
                    }}>
                        Sakthi Ganesh
                    </h3>
                    <p style={{
                        fontSize: "1rem",
                        opacity: 0.9,
                        marginBottom: "1.5rem",
                        lineHeight: "1.6"
                    }}>
                        Manage and edit the Sakthi Ganesh insolvency case content
                    </p>
                    <div style={{
                        display: "flex",
                        alignItems: "center",
                        gap: "0.5rem",
                        fontSize: "0.9rem",
                        opacity: 0.8
                    }}>
                        <span>🌐</span>
                        <span>ibcupdates.com/sakthiganesh</span>
                    </div>
                </div>
            </div>

            {/* Information Section */}
            <div style={{
                marginTop: "3rem",
                padding: "1.5rem",
                background: "#f5f5f5",
                borderRadius: "8px",
                borderLeft: "4px solid #009688"
            }}>
                <h4 style={{
                    color: "#009688",
                    marginBottom: "1rem",
                    fontSize: "1.2rem"
                }}>
                    ℹ️ How to Use
                </h4>
                <ul style={{
                    listStyle: "none",
                    padding: 0,
                    margin: 0,
                    color: "#555"
                }}>
                    <li style={{ marginBottom: "0.5rem", lineHeight: "1.6" }}>
                        • Click on any card above to open the respective insolvency case website in a new tab
                    </li>
                    <li style={{ marginBottom: "0.5rem", lineHeight: "1.6" }}>
                        • Each website has its own admin panel for content management
                    </li>
                    <li style={{ marginBottom: "0.5rem", lineHeight: "1.6" }}>
                        • Changes made on those websites are independent of this main admin panel
                    </li>
                    <li style={{ lineHeight: "1.6" }}>
                        • Make sure you're logged in to the respective admin panels before editing
                    </li>
                </ul>
            </div>

            {/* Quick Stats */}
            <div style={{
                marginTop: "2rem",
                display: "grid",
                gridTemplateColumns: "repeat(auto-fit, minmax(200px, 1fr))",
                gap: "1rem"
            }}>
                <div style={{
                    padding: "1.5rem",
                    background: "#fff",
                    borderRadius: "8px",
                    boxShadow: "0 2px 10px rgba(0,0,0,0.1)",
                    textAlign: "center"
                }}>
                    <div style={{ fontSize: "2rem", color: "#667eea", marginBottom: "0.5rem" }}>2</div>
                    <div style={{ color: "#666", fontSize: "0.9rem" }}>Active Cases</div>
                </div>
                <div style={{
                    padding: "1.5rem",
                    background: "#fff",
                    borderRadius: "8px",
                    boxShadow: "0 2px 10px rgba(0,0,0,0.1)",
                    textAlign: "center"
                }}>
                    <div style={{ fontSize: "2rem", color: "#009688", marginBottom: "0.5rem" }}>2</div>
                    <div style={{ color: "#666", fontSize: "0.9rem" }}>External Portals</div>
                </div>
            </div>
        </div>
    );
};

export default AdminInsolvencyCases;
